import { i18n } from '@flowus/common/i18n';
import { EmbedType } from '@flowus/common/embed-website';
import { BlockType } from '@next-space/fe-api-idl';
import { ListItemType } from 'src/common/components/list-view';
import { getIsDarkMode } from 'src/hooks/public/use-theme';
import { ossImagesPath } from 'src/image';
import { MenuListActionType } from './types';
import type { CSSProperties } from 'react';

/** 第三方应用数据 */
export const getEmbedData = () => {
  return [
    {
      title: 'Figma',
      placeholder: 'https://www.figma.com/...',
      embedType: EmbedType.figma,
    },
    {
      title: 'Airtable',
      placeholder: 'https://www.airtable.com/...',
      embedType: EmbedType.airtable,
      hidden: __BUILD_IN__,
    },
    {
      title: 'Sketch',
      placeholder: 'https://www.sketch.com/...',
      embedType: EmbedType.sketch,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.modao'),
      placeholder: 'https://www.modao.cc/...',
      embedType: EmbedType.modao,
      hidden: __BUILD_IN__,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.mockplus'),
      placeholder: 'https://app.mockplus.cn/...',
      embedType: EmbedType.mockplus,
      keywords: ['mockplus'],
      hidden: __BUILD_IN__,
    },
    {
      title: 'Excalidraw',
      placeholder: 'https://www.excalidraw.com/...',
      embedType: EmbedType.excalidraw,
    },
    {
      title: 'ProcessOn',
      placeholder: 'https://www.processon.com/...',
      embedType: EmbedType.processon,
    },
    {
      title: 'Canva',
      placeholder: 'https://www.canva.cn/...',
      embedType: EmbedType.canva,
    },
    {
      title: 'Bilibili',
      placeholder: 'https://www.bilibili.com/...',
      embedType: EmbedType.bilibili,
      hidden: __BUILD_IN__,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.vqq'),
      placeholder: 'https://v.qq.com/...',
      embedType: EmbedType.vqq,
      keywords: ['tencentvideo'],
      hidden: __BUILD_IN__,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.youku'),
      placeholder: 'https://v.youku.com/...',
      embedType: EmbedType.youku,
      keywords: ['youku'],
      hidden: __BUILD_IN__,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.xigua'),
      placeholder: 'https://www.ixigua.com/...',
      embedType: EmbedType.xigua,
      keywords: ['ixigua'],
      hidden: __BUILD_IN__,
    },
    {
      title: i18n.t('editor.component.menu_list.embeds_data.music163'),
      placeholder: 'https://music.163.com/...',
      embedType: EmbedType.music163,
      keywords: ['neteasemusic'],
      py: 'wangyiyunyinyue',
      initials: 'wyyyy',
      hidden: __BUILD_IN__,
    },
    {
      title: 'CodeSandbox',
      placeholder: 'https://www.codesandbox.io/...',
      embedType: EmbedType.codesandbox,
    },
    {
      title: 'CodePen',
      placeholder: 'https://www.codepen.io/...',
      embedType: EmbedType.codepen,
    },
  ].filter((i) => !i.hidden);
};

/** 第三方应用 */
export const getEmbedThirdParty = () => {
  const embedThirdParty: Record<
    string,
    {
      type: string;
      data: {
        type: BlockType.EMBED;
        image: string;
        title: string;
        imageStyle?: CSSProperties;
        // context: string;
        placeholder: string;
        keywords?: string[];
        actionType: MenuListActionType;
        py?: string;
        initials?: string;
        params: {
          data: { embedType: keyof typeof EmbedType };
          local: boolean;
        };
      };
    }
  > = {};

  const isDark = getIsDarkMode();

  getEmbedData().forEach(
    (item) =>
      (embedThirdParty[item.embedType] = {
        type: ListItemType.BLOCK_ITEM,
        data: {
          type: BlockType.EMBED,
          // src/pc/MIcBlockEmbedFigma.tsx
          actionType: MenuListActionType.CREATE,
          image: new URL(
            `${ossImagesPath}/embeds/${isDark ? 'dark' : 'light'}/ic_insert_${item.embedType}.png`
          ).href,
          title: item.title,
          // context: `嵌入 ${item.title}`,
          placeholder: item.placeholder,
          py: item.py,
          initials: item.initials,
          keywords: item.keywords,
          params: {
            data: { embedType: item.embedType },
            local: true,
          },
        },
      })
  );

  return embedThirdParty;
};
